<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{title}}</title>
    <path :fill="fill"
          d="M24,1C11.3,1,1,11.3,1,24s10.3,23,23,23s23-10.3,23-23S36.7,1,24,1z M34,25H14c-0.6,0-1-0.4-1-1s0.4-1,1-1 h20c0.6,0,1,0.4,1,1S34.6,25,34,25z"></path>
  </svg>
</template>

<script>
export default {
  name: "Minus",
  props: {
    title: {
      default: 'Effacer',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 34,
    },
  },
}
</script>
